import React from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import { Tooltip as AntdTooltip } from 'antd'
import './AiStatusBadge.scss'
import { useTranslation } from 'react-i18next'

const AiStatusBadge = ({ user, item }) => {
  if (
    user &&
    user.info &&
    user.info.organization &&
    user.info.organization.enable_ai &&
    item &&
    item.is_ai_enabled
  ) {
    const isIndexed = item.is_indexed
    const { t } = useTranslation()
    return (
      <AntdTooltip
        title={
          isIndexed
            ? t('v5:this_file_is_indexed_for_ai')
            : t('v5:file_is_not_indexed_for_ai')
        }
      >
        <span className={`ai-status-badge${isIndexed ? ' indexed' : ''}`}>
          <FaCheckCircle
            className={`ai-status-badge-icon${isIndexed ? ' indexed' : ''}`}
          />
          AI
        </span>
      </AntdTooltip>
    )
  }
  return null
}

export default AiStatusBadge
